// extracted by mini-css-extract-plugin
export var article_wrapper = "styles-module--article_wrapper--7fWdP";
export var article_title = "styles-module--article_title--gM9qQ";
export var image__wrapper = "styles-module--image__wrapper--Ib9X1";
export var post__content = "styles-module--post__content--a1A+t";
export var arrow = "styles-module--arrow--lH6uH";